var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.4052H22.5C22.5 6.27525 18.627 2.40625 13.49 2.40625V4.40625C17.552 4.40625 20.5 7.34925 20.5 11.4052Z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.40624C15.603 8.40624 16.5 9.30324 16.5 11.4062H18.5C18.5 8.18124 16.725 6.40624 13.5 6.40624V8.40624ZM16.922 13.8492C16.7298 13.6746 16.4773 13.5815 16.2178 13.5895C15.9582 13.5975 15.712 13.7061 15.531 13.8922L13.138 16.3532C12.562 16.2432 11.404 15.8822 10.212 14.6932C9.01998 13.5002 8.65898 12.3392 8.55198 11.7672L11.011 9.37324C11.1974 9.19237 11.3061 8.94607 11.3141 8.68645C11.3222 8.42684 11.2289 8.17429 11.054 7.98224L7.35898 3.91924C7.18402 3.7266 6.94086 3.60975 6.68113 3.5935C6.4214 3.57726 6.16557 3.6629 5.96798 3.83224L3.79798 5.69324C3.62509 5.86676 3.5219 6.0977 3.50798 6.34224C3.49298 6.59224 3.20698 12.5142 7.79898 17.1082C11.805 21.1132 16.823 21.4062 18.205 21.4062C18.407 21.4062 18.531 21.4002 18.564 21.3982C18.8085 21.3846 19.0393 21.2809 19.212 21.1072L21.072 18.9362C21.2414 18.7388 21.3273 18.483 21.3112 18.2233C21.2951 17.9636 21.1785 17.7203 20.986 17.5452L16.922 13.8492Z",
    fill: "#212529"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.eaba688049673e749978de49c72c4810.svg";
export { ForwardRef as ReactComponent };